var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drawer",
      class: _vm.drawerShow ? "drawer-open" : "drawer-close",
      attrs: { name: _vm.drawerName }
    },
    [
      _c("div", { staticClass: "drawer-body" }, [
        _c("div", {
          staticClass: "drawer-switch",
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "drawer-pages",
            class: _vm.pageShow ? "drawer-pages-open" : "drawer-pages-close"
          },
          [
            _c("addEmailPage", { ref: "addEmailPage" }),
            _vm._v(" "),
            _c("addCloudPage", { ref: "addCloudPage" })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b0668e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b0668e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/formwork/basic_drawer.vue
// module id = null
// module chunks = 